/* JSX */
import { useState } from "react";
import styles from "@/components/ui/toggle/ToggleSwitch.module.css";

const ToggleSwitch = ({ initialState = false, onChange }) => {
  const [toggleState, setToggleState] = useState(initialState);

  const handleToggle = () => {
    setToggleState(!toggleState);
    if (onChange) {
      onChange(!toggleState);
    }
  };

  return (
    <div className={styles["switch-container"]}>
      <label
        className={`${styles["switch-label"]} ${
          toggleState ? styles.active : ""
        }`}>
        {toggleState ? "More" : "More"}
      </label>
      <div
        onClick={handleToggle}
        className={`${styles["toggle-switch"]} ${
          toggleState ? styles.active : ""
        }`}>
        <div className={styles["toggle-switch-handle"]}></div>
      </div>
    </div>
  );
};

export default ToggleSwitch;
